import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type MasterLabelLinkProps = Omit<LinkProps, 'target' | 'rel'> & {
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
};

export const MasterLabelLink: React.FC<MasterLabelLinkProps> = ({
  target = '_blank',
  rel = 'noopener noreferrer',
  ...props
}) => <Link {...props} target={target} rel={rel} />;
